<div class="generalPage pb-0">
  <div class="pr-96px pt-104px">
    <div class="pendingheading prl-16px pb-24px" tabindex="0">{{pc_header}}</div>
    <div class="prl-16px mb-24px">
      <img class="success-icon" src="../../../assets/icons/Success.svg" alt="Sucess Img" />
      <span class="itcBookFont font-24 bold " tabindex="0">{{pendingEnabled}}</span>
    </div>
    <div class="pb-24px" style="padding-left:50px;">

      <div class="row pending-form-heading" tabindex="0">{{pc_beginningDate}}</div>
      <div tabindex="0" class="pending-form-value">{{integerationvalues.selectedDate}}</div>

      <div class="row pending-form-heading" tabindex="0">{{pc_filingStatuslabel}}</div>
      <div class="pending-form-value" tabindex="0">{{integerationvalues.selectedFillingStatus}}</div>

      <div class="row pending-form-heading" tabindex="0">{{pc_periodtypelabel}}</div>
      <div class="pending-form-value" tabindex="0">{{integerationvalues.selectedPeriodType}}</div>
    </div>
    <div class="prl-16px pb-24px" [innerHTML]="pc_confirmationMessage" tabindex="0"></div>
    <div class="mb-1">
      <button class="btn-primary-basic btn-Large mr-1rem cursor-pointer" (click)="ViewLastVisitedPage()" (keyup.enter)="ViewLastVisitedPage()" tabindex="0">
        {{pc_lastPageVisitedButton}}
      </button>
      <button class="btn-secondary-basic btn-l-basic cursor-pointer" (click)="Search()" (keyup.enter)="Search()" tabindex="0">
        {{pc_searchToolButton}}
      </button>
      <button class="btn-secondary-basic btn-l-basic cursor-pointer ml-1 right-Overlay" id="generalFeedback" appHostListenerClick tabindex="0">
        {{generalFeedback}}
      </button>
    </div>
  </div>
  <div class="background-gray generalPage pr-96px">
    <div class="georgiaFont font-24 pt-56" tabindex="0">{{pc_intergration_header}}</div>
    <div class="flex-display mb-24px mt-40px  info-box info-box-width">
      <div class="ml-12"><img src="../../../assets/icons/Info..svg" class="info-img" alt="Warning Info"></div>
      <label class="ml-0-5 para-content content-blue" [innerHTML]="pc_integrationStatus_Subtitle"></label>
    </div>

    <mat-accordion>
      <mat-expansion-panel [expanded]="true" class="accordian-width">
        <mat-expansion-panel-header class="mataccordianHeader">
          <div class="matheadertext" tabindex="0"> {{pc_integrationStatus_Accordion}}</div>
        </mat-expansion-panel-header>
        <table mat-table [dataSource]="dataSource" class="custom-mattable" aria-label="SpecialCases" aria-describedby="pendingcontent1">
          <ng-container matColumnDef="Standardssource">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_standardNumber}}</th>
            <td mat-cell *matCellDef="let element"> {{element.title}}</td>
          </ng-container>
          <ng-container matColumnDef="TransitionParagraph">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_transitionParagraph}}</th>
            <td mat-cell *matCellDef="let element">
              <span class="h-20px highlight-blue border-bottom-help cursor-pointer" (click)="RedirecttoPCS(element)" (keyup.enter)="RedirecttoPCS(element)" tabindex="0">{{element.transistionguidance}}</span>
            </td>
          </ng-container>
          <ng-container matColumnDef="Title">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_title}}</th>
            <td mat-cell *matCellDef="let element">{{element.body}} </td>
          </ng-container>
          <ng-container matColumnDef="IntegrationStatus">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_integrationStatus}}</th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.yesOrNo == '1'">Integrated</span>
              <span *ngIf="element.yesOrNo == '2'">Not Integrated</span>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
        <div *ngIf="dataSource.data?.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion>
      <mat-expansion-panel [expanded]="false" class="accordian-width">
        <mat-expansion-panel-header class="mataccordianHeader">
          <div class="matheadertext" tabindex="0"> {{pc_header_EarlyAdoptions_Accordian}}</div>
        </mat-expansion-panel-header>
        <table mat-table [dataSource]="dataSource_earlyAdoption" class="custom-mattable" aria-label="SpecialCases" aria-describedby="pendingcontent3">
          <ng-container matColumnDef="Standardssource">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_standardNumber}}</th>
            <td mat-cell *matCellDef="let element"> {{element.title}}</td>
          </ng-container>
          <ng-container matColumnDef="TransitionParagraph">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_transitionParagraph}}</th>
            <td mat-cell *matCellDef="let element">   <a class="h-20px highlight-blue cursor-pointer" (click)="RedirecttoPCS(element)" (keyup.enter)="RedirecttoPCS(element)" tabindex="0">{{element.transistionguidance}}</a></td>
          </ng-container>
          <ng-container matColumnDef="Title">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_title}}</th>
            <td mat-cell *matCellDef="let element">{{element.body}} </td>
          </ng-container>
          <ng-container matColumnDef="IntegrationStatus">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_integrationStatus}}</th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.yesOrNo == '1'">Integrated</span>
              <span *ngIf="element.yesOrNo == '2'">Not Integrated</span>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
        <div *ngIf="dataSource_earlyAdoption.data?.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
      </mat-expansion-panel>
    </mat-accordion>
    <mat-accordion>
      <mat-expansion-panel [expanded]="false" class="accordian-width">
        <mat-expansion-panel-header class="mataccordianHeader">
          <div class="matheadertext" tabindex="0"> {{pc_header_SpecialCases_Accordian}}</div>
        </mat-expansion-panel-header>
        <table mat-table [dataSource]="dataSource_specialCases" class="custom-mattable" aria-label="SpecialCases" aria-describedby="pendingcontent2">
          <ng-container matColumnDef="Standardssource">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_standardNumber}}</th>
            <td mat-cell *matCellDef="let element"> {{element.title}}</td>
          </ng-container>
          <ng-container matColumnDef="TransitionParagraph">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_transitionParagraph}}</th>
            <td mat-cell *matCellDef="let element">   <a class="h-20px highlight-blue cursor-pointer" (click)="RedirecttoPCS(element)" (keyup.enter)="RedirecttoPCS(element)" tabindex="0">{{element.transistionguidance}}</a></td>
          </ng-container>
          <ng-container matColumnDef="Title">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_title}}</th>
            <td mat-cell *matCellDef="let element">{{element.body}} </td>
          </ng-container>
          <ng-container matColumnDef="IntegrationStatus">
            <th scope="col" mat-header-cell *matHeaderCellDef>{{pc_integrationStatus}}</th>
            <td mat-cell *matCellDef="let element">
              <span *ngIf="element.yesOrNo == '1'">Integrated</span>
              <span *ngIf="element.yesOrNo == '2'">Not Integrated</span>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        </table>
        <div *ngIf="dataSource_specialCases.data?.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
      </mat-expansion-panel>
    </mat-accordion>

    <div class="mt-12 mb-2">
      <a class="mr-24px cursor-pointer" (click)="StartOver()" (keyup.enter)="StartOver()" tabindex="0"> {{pc_startOver}}<img src="../../../assets/icons/start-over.svg" alt="startover icon" /></a>
      <a class="mr-24px cursor-pointer" (click)="EditInput()" (keyup.enter)="EditInput()" tabindex="0">{{pc_editInputs}}<img class="ml-1px" src="../../../assets/icons/pencil-blue.svg" alt="edit icon" /></a>
    </div>
  </div>

</div>


